module.exports = __webpack_public_path__ + "img/image.bc5f3cb1.png";